import { Loader2 } from "lucide-react";

export function RouteFallback() {
  return (
    <div
      data-route-fallback
      className="flex min-h-[50vh] items-center justify-center"
    >
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      <span className="sr-only">Loading</span>
    </div>
  );
}
